import { createContext, useContext, useState, useEffect } from 'react';
import apiClient from '../api/client';

export interface SiteInfo {
  siteId: number;
  siteName: string;
  appName: string | null;
  logoUrl: string | null;
}

interface SiteContextValue {
  site: SiteInfo | null;
  loading: boolean;
}

const KNOWN_ROUTES = ['login', 'signup', 'createuser', 'settings', 'qr', 'enroll', 'schedule', 'email', 'forgotpassword', 'resetpassword'];

export function parseSiteNameFromUrl(): string | null {
  const parts = window.location.pathname.split('/').filter(Boolean);
  const candidate = parts[1]?.toLowerCase();
  if (!candidate || KNOWN_ROUTES.includes(candidate)) return null;
  return candidate;
}

const SiteContext = createContext<SiteContextValue>({ site: null, loading: false });

export function SiteProvider({ children }: { children: React.ReactNode }) {
  const [site, setSite] = useState<SiteInfo | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const siteName = parseSiteNameFromUrl();
    if (!siteName) return;

    setLoading(true);
    apiClient
      .get(`/Authentication/SiteInfo/${siteName}`)
      .then((res) => {
        const d = res.data?.data;
        if (d) {
          setSite({
            siteId:   d.siteId,
            siteName: d.siteName,
            appName:  d.appName  ?? null,
            logoUrl:  d.logoUrl  ?? null,
          });
        }
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return <SiteContext.Provider value={{ site, loading }}>{children}</SiteContext.Provider>;
}

export function useSite() {
  return useContext(SiteContext);
}
